import { render, staticRenderFns } from "./LuckyOrderIntro.vue?vue&type=template&id=2d67fe97&scoped=true"
import script from "./LuckyOrderIntro.vue?vue&type=script&lang=js"
export * from "./LuckyOrderIntro.vue?vue&type=script&lang=js"
import style0 from "./LuckyOrderIntro.vue?vue&type=style&index=0&id=2d67fe97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67fe97",
  null
  
)

export default component.exports